module.exports = __webpack_public_path__ + "static/media/download-android.c0de3e57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jornaleiro/download-android.jpg
// module id = 967
// module chunks = 0